import { render, staticRenderFns } from "./list.vue?vue&type=template&id=3da47049&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Option: require('/home/runner/work/myody_front/myody_front/components/option/Option.vue').default,Select: require('/home/runner/work/myody_front/myody_front/components/select/Select.vue').default,FormItem: require('/home/runner/work/myody_front/myody_front/components/form/FormItem.vue').default,Form: require('/home/runner/work/myody_front/myody_front/components/form/Form.vue').default,ListNews: require('/home/runner/work/myody_front/myody_front/components/list/ListNews.vue').default,Pagination: require('/home/runner/work/myody_front/myody_front/components/pagination/Pagination.vue').default,Card: require('/home/runner/work/myody_front/myody_front/components/card/Card.vue').default})
